// extracted by mini-css-extract-plugin
module.exports = {"StaffTable":"StaffTable_StaffTable__1PBH2","StaffTable__wrapper":"StaffTable_StaffTable__wrapper__28k8L"};